import { useMutation, useQueryClient } from '@tanstack/react-query'
import { EditRequestCommentInput, EditRequestCommentResponse } from '@omnea-app/comments/commentsFrontendClient'
import { CommentsHttpClient } from '@omnea-app/comments/commentsHttpClient'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { throwIfApiError } from '@omnea-app/packages/universal/error-handling/throwifApiError'
import { requestCommentsQueryKey } from './useGetRequestComment'

export const useEditRequestComment = ({ requestId }: { requestId: string }) => {
  const { getToken } = useAuthenticatedUser()
  const queryClient = useQueryClient()

  return useMutation<EditRequestCommentResponse, Error, EditRequestCommentInput>({
    mutationFn: async (body) => {
      const apiClient = new CommentsHttpClient({ authorization: await getToken() })
      const { data, error } = await apiClient.POST('/request/{commentId}', {
        body,
      })
      throwIfApiError(error)
      return data
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [requestCommentsQueryKey, requestId] })
    },
  })
}
